export default "__VITE_ASSET__CQ8PFR9c__"